import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient } from '@guiker/user-shared'

export const useAuthenticatedUserApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
